import IPostMessage from '../IPostMessage';
import IOSD from './IOSD';

/**
 * The `sos.osd` API groups together methods for working with the signageOS OSD (On Screen Display).
 *
 * More information about the OSD can be found in the [OSD Introduction](https://docs.signageos.io/hc/en-us/articles/4405231839890-OSD-menu-by-signageOS)
 *
 * <details>
 *     <summary>Front OSD Capabilities</summary>
 * 		| Capability | Description |
 * 		|:------------|:-------------|
 * 		| `FRONT_OSD` | If device supports opening OSD |
 *
 * 		If you want to check if the device supports this capability, use [`sos.display.supports()`](https://developers.signageos.io/sdk/sos/display#supports).
 * </details>
 */
export default class OSD implements IOSD {
	public static MESSAGE_PREFIX: string = 'osd';

	/** @internal */
	constructor(
		private messagePrefix: string,
		private postMessage: IPostMessage<any>,
	) {}

	/**
	 * The `showOSD()` method opens the OSD without typing the pin.
	 * Note: The OSD will be opened after 6 seconds.
	 *
	 * @returns {Promise<void>} A promise that resolves when the OSD is shown.
	 * @since 5.5.0
	 */
	public async showOSD(): Promise<void> {
		await this.postMessage({
			type: this.getMessage('show_osd'),
		});
	}

	private getMessage(name: string) {
		return this.messagePrefix + '.' + OSD.MESSAGE_PREFIX + '.' + name;
	}
}
